var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("path",{"d":"M18 0C8.06 0 0 8.058 0 18s8.06 18 18 18 18-8.058 18-18S27.94 0 18 0zm4.26 12.438h-2.705c-.32 0-.676.42-.676.985v1.952h3.382v2.788h-3.382v8.363h-3.195v-8.363h-2.896v-2.788h2.896v-1.638c0-2.35 1.63-4.263 3.87-4.263h2.707v2.964z","fill":"#FFF","fillRule":"evenodd","key":1})]);
}

Facebook.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Facebook;

Facebook.default = Facebook;
